<template>
    <el-dialog title="客服信息" :visible.sync="centerDialogVisible" :close-on-click-modal="false" width="600px" class="noBuyCode">
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <div class="codeName">
            <p class="title">客服名称</p>
            <el-input v-model.trim="noBuyData.servicename" :disabled="noBuyData.isOpen === 0" placeholder="请输入客服名称" maxlength="10" show-word-limit></el-input>
        </div>
        <div class="codeName">
            <p class="title">联系电话</p>
            <el-input v-model.trim="noBuyData.servicetel" :disabled="noBuyData.isOpen === 0" placeholder="请输入联系电话" type="tel" show-word-limit></el-input>
        </div>
        <div class="noBuyCodeBox">
            <p class="title">公众号二维码</p>
            <div class="upload cover-image" @click="openDialog">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img class="uploadImgIcon" :src="require('@/common/images/other/upload.png')" v-if="!img" alt="">
                        <img :src="img.furl +'?'+timestamp" alt="" class="uploadImg" v-else-if="img.furl &&  img.furl + '?' + timestamp">
                        <img :src="img + '?'+timestamp" alt="" class="uploadImg" v-else>
                        <div class="cover" v-if="img.furl || img">点击更换</div>
                        <img class="delete" @click.stop="deleteImg" :src="require('@/common/images/accountmgt/delete_img.png')" v-if="img.furl || img" alt="">
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {uploadShopServiceInfo} from 'api/accountApi'
export default {
    name: 'noBuyCode',
    data() {
        return {
            centerDialogVisible: false,
            img: '',
            noBuyData: {
                isOpen: 1,
                servicename: '',
                servicetel: ''
            },
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [110, 110], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 110, // 默认生成截图框宽度
                autoCropHeight: 110 // 默认生成截图框高度
            }
        }
    },
    props: ['data'],
    methods: {
        deleteImg() {
            this.img = ''
            this.noBuyData.serviceqrcodeurl = ''
            this.noBuyData.serviceqrcodeid = ''
        },
        open() {
            this.centerDialogVisible = true
            this.noBuyData.servicename = this.data.servicename
            this.noBuyData.servicetel = this.data.servicetel
            this.noBuyData.serviceqrcodeid = this.data.serviceqrcodeid
            this.noBuyData.serviceqrcodeurl = this.data.serviceqrcodeurl
            this.img = this.data.serviceqrcodeurl
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.img = file
        },
        confirm() {
            let options = {
                serviceqrcodeid: this.img.key ? this.img.key : this.noBuyData.serviceqrcodeid,
                serviceqrcodeurl: this.img.furl ? this.img.furl : this.noBuyData.serviceqrcodeurl,
                servicename: this.noBuyData.servicename,
                servicetel: this.noBuyData.servicetel
            }
            this.setLoading(true)
            uploadShopServiceInfo({
                data: options,
                success: data => {
                    this.setLoading(false)
                    this.centerDialogVisible = false
                    // this.$message.success('setOfficalMsg')
                    this.$emit('setServiceMsg',options)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    // this.noBuyData.isOpen = newV.issubscribe
                    
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .noBuyCode{
        .title{
            width: 98px;
        }
        .openClose{
            display: flex;
            margin-bottom: 15px;
            .el-radio-group{
                margin-left: 40px;
                .el-radio__input.is-checked+.el-radio__label{
                    color: #303133;
                }
            }
            .tips{
                margin-left: 10px;
                color: #909399;
            }
        }
        .codeName{
            display: flex;
            margin-bottom: 15px;
            align-items: center;
            .el-input{
                margin-left: 40px;
                width: 400px;
            }
        }
        .noBuyCodeBox{
            display: flex;
            justify-content: flex-start;
            .upload{
                margin-left: 40px;
                .avatar-uploader{
                    display: flex;
                    .el-upload{
                        width: 110px;
                        height: 110px;
                        margin-right: 10px;
                        background: #F5F7FA;
                        line-height: 110px;
                        text-align: center;
                        overflow: visible;
                        .uploadImgIcon{
                            width: 21px;
                            height: 21px;
                        }
                        .uploadImg{
                            width: 110px;
                            height: 110px;
                        }
                        .cover {
                            width: 110px;
                            height: 110px;
                            position: absolute;
                            line-height: 110px;
                            text-align: center;
                            background: rgba($color: #333333, $alpha: 0.4);
                            color: #fff;
                            font-size: 12px;
                            display: none;
                        }
                        &:hover {
                            .cover {
                                display: block;
                            }
                        }
                        .delete {
                            position: absolute;
                            right: -7px;
                            top: -7px;
                            width: 15px;
                            height: 15px;
                        }
                    }
                    .el-upload__tip{
                        color: #C0C4CC;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
